import './MembersStructure.scss';

import { Grid, ThemeProvider, useMediaQuery } from '@mui/material';
import { Structure } from 'domain/structure/Structure';
import {
  StructureMember,
  StructureMemberFilters,
} from 'domain/structureMember/StructureMember';
import { StructureMemberState } from 'domain/structureMember/StructureMemberState';
import { LayoutList } from 'primary/Components/Layout/Lists/LayoutList';
import { ListElements } from 'primary/Components/ListElements/ListElements';
import { UseFetchWithFilterPageReturn } from 'primary/hooks/useFetchWithFilterPage';
import { useTranslate } from 'primary/hooks/useTranslate';
import { PreviewCardProfilWithRole } from 'primary/Parameters/structure/Admin/PreviewCardProfilWithRole';
import { StructureMemberSwitchView } from 'primary/Structure/StructureMemberSwitchView';
import React from 'react';

import { themeParameters } from '../../parameters.helper';
import { useStructureParameters } from '../../user/useUserStructureParameters.hook';

type MembersStructureCompProps = {
  readonly?: boolean;
  onlyAccepted?: boolean;
  structure: Structure;
  withoutTitle?: boolean;
  onClickEditMember?: (member: StructureMember) => void;
  useFetchReturn: UseFetchWithFilterPageReturn<StructureMember, StructureMemberFilters>;
  className?: string;
  classNameDatatable?: string;
  onClickDeleteMember?: (member: StructureMember) => void;
  canDelete?: boolean;
};

export const MembersStructure = () => {
  const { structure, refrehStructure } = useStructureParameters();
  //@ts-ignore
  const isMobile = useMediaQuery((theme) => theme?.breakpoints?.down('md'));

  return (
    <StructureMemberSwitchView
      isMobile={isMobile}
      structure={structure}
      readonly={false}
      onEditted={refrehStructure}
      withInfosRole
    />
  );
};

export const MembersStructureComp = ({
  readonly,
  structure,
  withoutTitle,
  onClickEditMember,
  onlyAccepted,
  useFetchReturn,
}: MembersStructureCompProps) => {
  const t = useTranslate();

  if (!structure) return null;

  return (
    <div className={'membersStructure'}>
      <ThemeProvider theme={themeParameters}>
        <div className={'membersStructure__list'}>
          <LayoutList
            withoutBorder
            opaq
            opaqBody
            className={'-layoutMembersStructure'}
            tablePagination
            resetFilters={() => useFetchReturn.setFilters({})}
            keyDomainFilter={'structureMember'}
            paginationProps={{
              goToPage: useFetchReturn.goToPage,
              currentPage: useFetchReturn.fetchedResource?.currentPage,
              numberOfItem: useFetchReturn.fetchedResource?.totalElementsCount,
              setRowPerPage: useFetchReturn.changeNbPerPage,
              numberOfItemPerPage: useFetchReturn.fetchedResource?.pageSize,
              pagesCount: useFetchReturn.fetchedResource?.pagesCount || 0,
            }}
            pagination
            listComponent={
              <ListElements
                loading={useFetchReturn.loading}
                empty={useFetchReturn.fetchedResource?.content.length === 0}
              >
                <Grid container>
                  {!useFetchReturn.loading &&
                    useFetchReturn.fetchedResource?.totalElementsCount !== 0 &&
                    useFetchReturn.fetchedResource?.content.map((member) => (
                      <PreviewCardProfilWithRole
                        readonly={readonly}
                        key={member.user.id}
                        className={'-item'}
                        profil={member.user.userProfil}
                        member={member}
                        structure={structure}
                        userId={member.user.id}
                        onSubmitted={() => useFetchReturn.retry()}
                        role={member.role}
                        isTemp={member?.state !== StructureMemberState.ACCEPTED}
                        onClickEditMember={() =>
                          onClickEditMember && onClickEditMember(member)
                        }
                      />
                    ))}
                </Grid>
              </ListElements>
            }
            // @ts-ignore
            filtersTag={useFetchReturn?.activeFilters?.filters}
            noTags
            onDeleteFilter={(filter) => {
              useFetchReturn.setFilters({
                ...useFetchReturn.activeFilters?.filters,
                [filter.key]: undefined,
              });
            }}
          />
        </div>
      </ThemeProvider>
    </div>
  );
};
